'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'swatchbook';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f5c3';
var svgPathData = 'M0 400c0 61.9 50.1 112 112 112l328 0c39.8 0 72-32.2 72-72l0-80c0-35.4-25.6-64.9-59.3-70.9L405.8 336 440 336c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24L209.9 464 431 242.9c28.1-28.1 28.1-73.7 0-101.8L370.9 81c-27.2-27.2-70.6-28.1-98.9-2.8l0 67.7 31-31c9.4-9.4 24.6-9.4 33.9 0L397.1 175c9.4 9.4 9.4 24.6 0 33.9L224 382.1 224 72c0-39.8-32.2-72-72-72L72 0C32.2 0 0 32.2 0 72L0 400zm112 64c-35.3 0-64-28.7-64-64l0-96 128 0 0 96c0 35.3-28.7 64-64 64zM48 256l0-80 128 0 0 80-128 0zm0-128l0-56c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 56-128 0zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwatchbook = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;